"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _madLibForm = _interopRequireDefault(require("./mad-lib-form"));

var _sections = require("../contentful-views/sections");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Helper to extract needed fields from ButtonLink Contentful model
 * @param {Object} model Contentful model for button link
 */
var ctaModel = function ctaModel(model) {
  return model ? {
    props: {
      type: _lodash["default"].get(model, 'fields.type'),
      size: _lodash["default"].get(model, 'fields.size')
    },
    text: _lodash["default"].get(model, 'fields.text')
  } : null;
};
/**
 * Contentful Widget to map MadLibForm to it's custom component.
 */


var MadLibFormWidget = function MadLibFormWidget(_ref) {
  var model = _ref.model,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      className = _ref.className;

  var id = _lodash["default"].get(model, 'fields.id');

  var salutation = _lodash["default"].get(model, 'fields.salutation');

  var salutationColor = _lodash["default"].lowerCase(_lodash["default"].get(model, 'fields.salutationColor'));

  var secondarySalutation = _lodash["default"].get(model, 'fields.secondarySalutation');

  var bannerImage = _lodash["default"].get(model, 'fields.bannerImage');

  var image = _lodash["default"].get(model, 'fields.image');

  var cancelCTA = ctaModel(_lodash["default"].get(model, 'fields.cancelCta'));

  var text = _lodash["default"].get(model, 'fields.madLibText');

  var primaryCTA = ctaModel(_lodash["default"].get(model, 'fields.cta'));

  var pendingText = _lodash["default"].get(model, 'fields.pendingText');

  var formType = _lodash["default"].get(model, 'fields.formType');

  var segmentationCards = _lodash["default"].map(_lodash["default"].get(model, 'fields.segmentationCards'), function (_ref2) {
    var fields = _ref2.fields;
    return {
      title: _lodash["default"].get(fields, 'title'),
      image: _lodash["default"].get(fields, 'images[0]')
    };
  });

  var radioButtonOptions = _lodash["default"].map(_lodash["default"].get(model, 'fields.segmentationCards'), function (_ref3) {
    var fields = _ref3.fields;
    return {
      value: _lodash["default"].get(fields, 'id'),
      label: _lodash["default"].get(fields, 'text')
    };
  }); // Hard-coding radio button form field name to match existing pattern


  var radioButtonsFieldName = id || 'segment';

  var includeOtherOption = _lodash["default"].get(model, 'fields.includeOtherOption', true);

  var radioButtons = {
    name: radioButtonsFieldName,
    includeOtherOption: includeOtherOption,
    options: radioButtonOptions
  }; // Return function so we can pass in onSubmit.

  return /*#__PURE__*/_react["default"].createElement(_madLibForm["default"], {
    bannerImage: bannerImage,
    className: className,
    cancelCTA: cancelCTA,
    image: image,
    formType: formType,
    onCancel: onCancel,
    onSubmit: onSubmit,
    pendingText: pendingText,
    primaryCTA: primaryCTA,
    salutation: salutation,
    salutationColor: salutationColor,
    secondarySalutation: secondarySalutation,
    segmentationCards: segmentationCards,
    radioButtons: radioButtons,
    text: text
  });
};

MadLibFormWidget.propTypes = {
  model: _propTypes["default"].shape({}),
  onSubmit: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  className: _propTypes["default"].string
};
MadLibFormWidget.defaultProps = {
  model: {},
  onSubmit: _lodash["default"].noop,
  onCancel: _lodash["default"].noop,
  className: null
};
(0, _sections.registerWidget)('madLibForm', MadLibFormWidget);
var _default = MadLibFormWidget;
exports["default"] = _default;